// Area Navigation component

// This file was once generated when you created this area
// but you can edit it freely

import {
  type AreaNavigationProps,
  NavigationItem,
} from '@backoffice-frontend/patterns'
import { DeviceDesktopIcon } from '@moia-dev/pace-icons'
import { VirtualTestingAreaRoutes } from './VirtualTestingAreaRoutes'

export const VirtualTestingAreaNavigationIcon = DeviceDesktopIcon

export const VirtualTestingAreaNavigation = ({
  onClick,
  open,
  label,
}: AreaNavigationProps) => {
  return (
    <NavigationItem
      onClick={onClick}
      open={open}
      label={label}
      to={VirtualTestingAreaRoutes.route}
      Icon={DeviceDesktopIcon}
    />
  )
}
